export const
    DEFAULT = "DEFAULT",
    UNDO = "UNDO",
    REDO = "REDO",
    SET_CURRENT_ELEMENT_INDEX = "SET_CURRENT_ELEMENT_INDEX",
    SET_CURRENT_PAGE = "SET_CURRENT_PAGE",
    SET_PAGE = "SET_PAGE",
    UPDATE_PAGE = "UPDATE_PAGE",
    REMOVE_PAGE = "REMOVE_PAGE",
    SET_PAGES = "SET_PAGES",
    SET_PAGE_ELEMENTS = "SET_PAGE_ELEMENTS",
    SET_PAGE_ELEMENT = "SET_PAGE_ELEMENT",
    REMOVE_PAGE_ELEMENT = "REMOVE_PAGE_ELEMENT",
    SET_IS_DARK_MODE = "SET_IS_DARK_MODE",
    SET_SNAP_ENABLED = "SET_SNAP_ENABLED",
    START_DRAG = "START_DRAG",
    STOP_DRAG = "STOP_DRAG",
    START_RESIZE = "START_RESIZE",
    HANDLE_DRAG = "HANDLE_DRAG",
    CREATE_DEFAULT_THEME = "CREATE_DEFAULT_THEME",
    SET_PREVIEW_SCALE = "SET_PREVIEW_SCALE",
    ADD_ELEMENT = "ADD_ELEMENT",
    UPDATE_PROPERTY = "UPDATE_PROPERTY",
    UPDATE_RESSOURCE = "UPDATE_RESSOURCE",
    UNSELECT_ELEMENT = "UNSELECT_ELEMENT",
    ADD_TO_HISTORY = "ADD_TO_HISTORY",
    UPDATE_ORDER_PROPERTY = "UPDATE_ORDER_PROPERTY",
    REMOVE_SHURTCUT_ACTION = "REMOVE_SHURTCUT_ACTION",
    CREATE_COMPOSITION = "CREATE_COMPOSITION",
    SET_COMPOSITIONS = "SET_COMPOSITIONS",
    SET_COMPOSITION_EDITING = "SET_COMPOSITION_EDITING",
    ADD_COMPOSITION = "ADD_COMPOSITION",
    CREATE_DEFAULT_COMPOSITION = "CREATE_DEFAULT_COMPOSITION",
    ADD_COMPOSITION_ELEMENT = "ADD_COMPOSITION_ELEMENT",
    REMOVE_COMPOSITION_ELEMENT = "REMOVE_COMPOSITION_ELEMENT",
    SAVE_COMPOSITION_EDIT = "SAVE_COMPOSITION_EDIT",
    UPDATE_POSSIBLE_COMPOSITIONS_THUMBNAIL = "UPDATE_POSSIBLE_COMPOSITIONS_THUMBNAIL",
    UPDATE_SNAP_GUIDELINES = "UPDATE_SNAP_GUIDELINES",
    SET_CURRENT_ELEMENT = "SET_CURRENT_ELEMENT",
    SET_USER = "SET_USER",
    SET_ACTION_LOADING = "SET_ACTION_LOADING",
    SET_RESSOURCES = "SET_RESSOURCES",
    SET_MESSAGES = "SET_MESSAGES",
    REMOVE_RESSOURCE = "REMOVE_RESSOURCE",
    REMOVE_MESSAGE = "REMOVE_MESSAGE",
    ADD_ALERT = "ADD_ALERT",
    REMOVE_ALERT = "REMOVE_ALERT",
    REMOVE_COMPOSITION = "REMOVE_COMPOSITION",
    LOAD_FONT = "LOAD_FONT",
    CLEAR_FONT_PROMISE_LIST = "CLEAR_FONT_PROMISE_LIST",
    SET_THEME_NAME = "SET_THEME_NAME",
    SET_THEME_DESCRIPTION = "SET_THEME_DESCRIPTION",
    SET_THEME_LIST = "SET_THEME_LIST",
    SELECT_THEME = "SELECT_THEME",
    SET_THEME_ID = "SET_THEME_ID",
    SET_THEME_JSON = "SET_THEME_JSON",
    SET_PREVIEW_SCALE_COMPOSITION = "SET_PREVIEW_SCALE_COMPOSITION",
    SET_ACTIVE_COMPOSITION_FROM_THEME = "SET_ACTIVE_COMPOSITION_FROM_THEME",
    SET_THEME_THUMBNAIL = "SET_THEME_THUMBNAIL",
    REMOVE_THEME = "REMOVE_THEME",
    SET_THEME_MODIFICATION_NOT_SAVED = "SET_THEME_MODIFICATION_NOT_SAVED",
    SET_USED_SCALE = "SET_USED_SCALE",
    SET_COPIED_ELEMENT = "SET_COPIED_ELEMENT",
    PASTE_COPIED_ELEMENT = "PASTE_COPIED_ELEMENT"
